module.exports = __webpack_public_path__ + "assets/img/title-dcb32381.png";